
import { downloaderSender } from '@/api/anycubic_axios';



class Downloader {
    /**
    * 登录
    * @param file_path 文件路径(一般仅为文件名)
    * @returns {number} 0表示成功，其他为错误码
    */
    remove_file(file_path) {
        let response = -1;
        downloaderSender.del("remove_file", { "file_path": file_path, })
            .then(res => response = res)
        return response

    }

    /**
     * 登录
     * @param file_path 文件路径(一般仅为文件名)
     * @returns {number} 0表示不存在，其他为存在
     */
    async exists_file(file_path) {
        const res = await downloaderSender.get("exists_file", { "file_path": file_path, })
        let response = res?.code === 200 ? res?.data : -1;
        return response
    }

    /**
     * @describe 计算md5值
     * 
     * @param file_path 文件路径(一般仅为文件名)
     * @param fast 快速度算法启用；1启用，0不启用
     */
    async file_md5(file_path, fast) {
        // todo: 这里要改，不对的
        let response = -1;
        response = await downloaderSender.get("file_md5", { "file_path": file_path, "fast": fast })
            .then(res => response = res)
        return response.data ? response.data : -1
    }

    /**
* @describe 注册消息接收回调
* 
* @param callback 回调函数
* @returns 成功返回0,失败返回错误代码
*/
    set_notify(Function) {
        window.finished_notify = Function;
        let response = -1;
        downloaderSender.post("finished_notify", { "script": "window.finished_notify" })
            .then(res => response = res)
        return response
    }
    /**
 * @describe 移动文件
 * 
 * @param dst_path 目标文件路径-- 如果目标目录不存在，则自动创建
 * @param src_path 源文件路径
 * @returns 成功返回0,失败返回错误代码
 */
    move_file(dst_path, src_path) {

        let response = -1;
        downloaderSender.put("move_file", { "dst_path": dst_path, "src_path": src_path })
            .then(res => response = res)
        return response

    }
}

export function CreateDownloader() {
    return new Downloader;
}